<div class="container-fluid policy-bg">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-8 banner-content pe-0 pe-lg-5">
                <h1 class="banner-heading-one py-3">Cookie Policy</h1>
            </div>
            <div class="col-lg-4 banner-content banner-sub-img">
                <img src="../../../../../assets/company/legal-policies/cookie-policy.svg" class="img-fluid" alt="cookie-policy">
            </div>
        </div>
    </div>
</div>

<div class="cookie-policybody">
    <div class="container pb-5">
        <div class="row">
            <div class="col-md-12">
                <p class="pt-5">Our Cookie Policy was last updated on <strong>4th January 2024.</strong></p>
                <p class="pb-3">Kalpita Technologies and affiliates ("company", "we", "us", or "our") understand that your privacy is
                    important to you and are committed to being transparent about the technologies used. This Cookie
                    Policy explains what cookies are and how we use them. Read this policy to understand the cookies we
                    use and similar tracking technologies on our website, particularly the use of Google Analytics. By
                    using our website, you consent to the use of cookies as described in this policy. </p>
                <!-- What are Cookies? .............................................. -->
                <h4>What are Cookies? </h4>
                <p>Cookies are small text files that are stored on your device (computer, mobile, tablet) when you visit
                    a website. This contains your browsing history details on the website among its other uses. They are
                    widely used to make websites work more efficiently and to provide information to website owners.
                </p>
                <!-- How We Use Cookies  ...................................................... -->
                <h4>How We Use Cookies </h4>
                <p>Kalpita Technologies uses cookies primarily to analyze user interactions with our website through
                    Google Analytics. This helps us understand how visitors use our site, which pages are most
                    frequently visited, how long they spend on each page and other similar information. The data
                    collected through these cookies is used solely for analytical purposes to improve our website's
                    content, functionality, and user experience. </p>
                <!-- Type of Cookies We Use  ................................................................. -->
                <h4>Type of Cookies We Use </h4>
                <p>Google Analytics Cookies: These cookies are set by Google Analytics and enable us to collect
                    information about how visitors use our website. They help us analyze user behavior and improve our
                    site's performance. Google Analytics cookies may track your IP address, browser type, device
                    information, and website usage patterns. </p>
                <!-- Managing Cookies ............................................................................. -->
                <h4>Managing Cookies </h4>
                <p>You can control and manage cookies in various ways. You can accept or reject cookies, and delete
                    existing cookies. Please note that if you choose to block or delete cookies, some parts of our
                    website may not function properly. </p>

                <!-- Consent to Use Cookies ................................................................... -->
                <h4>Consent to Use Cookies </h4>
                <p>By using our website, you consent to the use of cookies as described in this policy. You can withdraw
                    your consent at any time by changing your browser settings to disable cookies. </p>

                <!-- Changes to This Policy  ...................................................................... -->
                <h4>Changes to This Policy </h4>
                <p>We may update this Cookie Policy from time to time to reflect changes in our practices or for other
                    operational, legal, or regulatory reasons. Any changes will be posted on this page, and we encourage
                    you to review this policy periodically. </p>

                <!-- Contact Us................................................................... -->
                <h4>Contact Us </h4>
                <p>If you have any questions or concerns about our use of cookies or this Cookie Policy, please get in touch with us at <a
                        href="mailto:connect@kalpitatechnologies.com" target="_blank"> connect&#64;kalpitatechnologies.com</a></p>
            </div>
        </div>
    </div>

</div>